<template>
  <div class="container-fluid">
    <h5>Media - Video</h5>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Video URL</span>
      </div>
      <div class="vx-col sm:w-3/5 w-full">
        <vs-input class="w-full" v-if="question.configMediaVideo" v-model="question.configMediaVideo.videoUrl"
          placeholder="Video URL..." />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Thumbnail URL</span>
      </div>
      <div class="vx-col sm:w-3/5 w-full">
        <vs-input class="w-full" v-if="question.configMediaVideo" v-model="question.configMediaVideo.thumbnailUrl"
          placeholder="Thumbnail URL..." />
      </div>
    </div>

  </div>
</template>

<style lang="scss" scoped>
</style>

<script>

export default {
  name: "QuestionConfigMediaVideo",
  components: {},
  directives: {
  },
  props: ['question'],
  data() {
    return {
    };
  },
  mounted() {
    if (!this.question.configMediaVideo || this.question.configMediaVideo === null) {
        this.question.configMediaVideo = {
            videoUrl: '',
            thumbnailUrl: ''
        };
    }
  },
  beforeDestroy: function() {
  },
  methods: {}
};
</script>